/**
 * FV イラスト：表示時は GSAP、表示後は CSS ループ
 * - PC: 6つを順番に（stagger）表示 → ロゴ
 * - SP: ランダムで選ばれた1つのみ同じアニメーション → ロゴ（順番待ちなし）
 */

import { $ } from "./utils.js";

const ENTERED_CLASS = "fv-illusts--entered";
const SP_BREAKPOINT = "(max-width: 1023px)"; // Tailwind max-lg
const SP_VISIBLE_CLASS = "max-lg:opacity-0"; // SPで非表示の要素はこのクラスを持つ

function showLogo() {
  const gsap = window.gsap;
  const logo = $(".fv-logo");
  if (logo) {
    gsap.fromTo(logo, {
      opacity: 0,
      scale: 0.6,
    },{
      opacity: 1,
      scale: 1,
      duration: 1.6,
      ease: "back.inOut(4)",
    });
    logo.classList.add("fv-logo--visible");
  }
}

function showLogoAndEntered(container) {
  container.classList.add(ENTERED_CLASS);
  showLogo();
}

function runEntranceAnimation(container) {
  const gsap = window.gsap;
  const allItems = Array.from(container.querySelectorAll(".fv-illust"));
  if (allItems.length === 0) return;

  const isSP = window.matchMedia(SP_BREAKPOINT).matches;
  const itemsToAnimate = isSP
    ? allItems.filter((el) => !el.classList.contains(SP_VISIBLE_CLASS))
    : allItems;

  if (itemsToAnimate.length === 0) {
    showLogoAndEntered(container);
    return;
  }

  if (!gsap) {
    showLogoAndEntered(container);
    return;
  }

  const duration = 1;
  const stagger = isSP ? 0 : 0.08;
  const logoDelay = Math.max(0, duration + (itemsToAnimate.length - 1) * stagger - 0.6);

  if (logoDelay > 0) {
    gsap.delayedCall(logoDelay, showLogo);
  } else {
    showLogo();
  }

  gsap.fromTo(
    itemsToAnimate,
    {
      opacity: 0,
      scale: 0.6,
    },
    {
      opacity: 1,
      scale: 1,
      duration,
      ease: "back.inOut(4)",
      stagger,
      onComplete: () => {
        gsap.set(itemsToAnimate, { clearProps: "all" });
        // container.classList.add(ENTERED_CLASS);
      },
    }
  );
}

function init() {
  const container = $("#fv-illusts");
  if (!container) return;

  container.addEventListener("fvillusts:ready", () => {
    runEntranceAnimation(container);
  });
}

init();
